import GoalMeasures from '@/utils/constants/pei/peiGoalMeasures';

export const BuildGoalDescription = (goal) => {
    const adequacyText = BuildAdequacyText(goal.adequacyData);
    const description = `${goal.term ? `${goal.term.name},` : ''} ${goal.studentName} ${goal.activity} ${goal.suitability ? goal.suitability.name : ''}`;
    const result = !!adequacyText ? `${description}. ${FirstLetterToUpperCase(adequacyText)}.` : `${description}.`;

    return FirstLetterToUpperCase(result);
}

export const BuildObjetiveDescription = (objetive) => {
    const description = `${objetive.description} ${(objetive.instrument?.name ?? '').toLocaleLowerCase()}`;

    if (!objetive.adequacy?.id) {
        const temp = FirstLetterToUpperCase(description);
        return !temp.replace(/\s/g,'').length ? '' : `${temp}.`
    }

    const adequacyText = BuildAdequacyText(objetive);
    
    return FirstLetterToUpperCase(`${description} ${adequacyText}.`);
};

export const BuildAdequacyText = (data) => {
    if (!data?.adequacy?.id) return '';

    const isAttemptMeasure = data.adequacy.id == GoalMeasures.attempts;
    const adecuation1 = isAttemptMeasure ? `en ${data.measure1Amt ?? ''}` : `en un ${data.measure1Amt ?? ''}%`;
    const adecuation2 = isAttemptMeasure ? `de ${data.measure2Amt ?? ''}` : '';

    return `${adecuation1} ${adecuation2}`;
};

export const FirstLetterToUpperCase = (description) => `${description[0].toUpperCase()}${description.slice(1)}`;
    